<template>
    <h1 class="px-4 text-center text-2xl font-bold lg:text-4xl lg:leading-[1.25]">
        <slot />
    </h1>
</template>
